module.exports = __webpack_public_path__ + "media/image5.be15eefd.mp4";